import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import CloseIcon from './../../assets/img/close-icon.svg';
import Button from './../../components/button/Button'

import styles from './ReadMoreScreen.module.css';

class ReadMoreScreen extends Component {

    constructor(props) {
        super(props);

        window.scrollTo(0, 0);

        this.state = {
            topbarAnimation: "hidden",
            pageTransitionEnd: false
        }

        this.backToPlaceDetails = this.backToPlaceDetails.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
    }

    componentDidMount(props){
        window.addEventListener('popstate', function(evt){
            let pathname = evt.target.location.pathname;
            this.props.history.replace(pathname, {
                animation: "slideInLeft"
            });
        }.bind(this));
        window.onscroll = function(){
            if(window.pageYOffset >= 50 && this.state.topbarAnimation !== "open"){
                this.setState({
                    topbarAnimation: "open"
                });
            }
            if(window.pageYOffset < 50 && this.state.topbarAnimation === "open"){
                this.setState({
                    topbarAnimation: "close"
                });
            }
        }.bind(this);
    }

    backToPlaceDetails() {
        this.props.history.goBack();
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    render() {
        let topbarAnimation, animation = "";
        if(!this.state.pageTransitionEnd){
            animation = " animated slideInUp";
        }
        if(this.state.topbarAnimation === "open"){
            topbarAnimation = "animated slideInDown";
        }
        if(this.state.topbarAnimation === "close"){
            topbarAnimation = "animated slideOutUp";
        }
        if(this.state.topbarAnimation === "hidden"){
            topbarAnimation = styles.hidden;
        }

        return (
            <div className={"page"}>
                <Button onClick={this.backToPlaceDetails} className={styles.closeButton} styleType="rounded">
                    <ReactSVG src={CloseIcon}/>
                </Button>
                <div className={[styles.header, topbarAnimation].join(' ')}>
                    <h4 className="h4Bold">{this.props.place ? this.props.place.point_name : ''}</h4>
                </div>
                <div className={animation} onAnimationEnd={this.animationEnd}>
                    <div className={styles.termsSection}>
                        <h3>{this.props.place ? this.props.place.point_name : ''}</h3>
                        <p>{this.props.place ? this.props.place.point_desc : ''}</p>
                    </div>
                </div>
            </div>
        );
    }

}

export default ReadMoreScreen;